import { render, staticRenderFns } from "./PollsPage.vue?vue&type=template&id=39efe1eb&scoped=true&"
import script from "./PollsPage.vue?vue&type=script&lang=js&"
export * from "./PollsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39efe1eb",
  null
  
)

export default component.exports